var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageExchangeGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.6 61.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1fba9c;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xDCzenetv\\xE1lt\\xE1s"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "47.08 26.87 52.6 26.87 52.6 53.21 41.46 53.21 50.18 60.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "11.38 39.37 11.38 53.21 32.31 53.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "21.29 8.3 42.22 8.3 42.22 34.64 1 34.64 1 8.3 12.13 8.3 3.42 0.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.67,
    y1: 21.68,
    x2: 23.83,
    y2: 21.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.43,
    y1: 21.68,
    x2: 31.59,
    y2: 21.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.92,
    y1: 21.68,
    x2: 16.08,
    y2: 21.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.01,
    y1: 41.39,
    x2: 33.17,
    y2: 41.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.76,
    y1: 41.39,
    x2: 40.92,
    y2: 41.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.25,
    y1: 41.39,
    x2: 25.41,
    y2: 41.39
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageExchangeGreen);
export default __webpack_public_path__ + "static/media/messageExchangeGreen.69e96f64ea6f61fe3e36341c4044e194.svg";
export { ForwardRef as ReactComponent };